export class Scoring {
  private numberOfRowsCleared: number;

  constructor() {
    this.numberOfRowsCleared = 0;
  }

  addClearedRows(n: number) {
    this.numberOfRowsCleared += n;
  }

  getLevel() {
    return this.levelByNumberOfLowsCleared(this.numberOfRowsCleared);
  }

  getSecondsPerLine() {
    return this.secondsPerLineByLevel(this.getLevel());
  }

  getNumberOfClearedRows() {
    return this.numberOfRowsCleared;
  }

  private levelByNumberOfLowsCleared(numberOfRowsCleared: number) {
    return Math.min(1 + Math.floor(numberOfRowsCleared / 10), 15);
  }

  private secondsPerLineByLevel(level: number) {
    return ([
      1.0,
      0.793,
      0.618,
      0.473,
      0.355,
      0.262,
      0.190,
      0.135,
      0.094,
      0.064,
      0.043,
      0.028,
      0.018,
      0.011,
      0.007
    ])[level - 1];
  }
}
